import React, { useEffect, useMemo, useState } from 'react';
import { Formik, Field } from 'formik';
import { isEqual } from 'lodash';
import { useKurbanListUIContext } from '../KurbanUIContext';
import { initialFilter } from '../KurbanUIHelpers'
import { getFundtypeAll } from "../../../../../MasterData/_redux/fund_type/fundtypeCrud";
import { getBankAll } from "../../../../../MasterData/_redux/bank/bankCrud";
import * as requestCh from '../../../../../MasterData/_redux/channels/channelsCrud';
import { getKurbanList } from "../../../../_redux/kurban/kurbanCrud";
import { DateRangePicker } from 'react-dates';
import moment from 'moment'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';



const prepareFilter = (queryParams, values) => {
    const {
        is_name,
        donation_hid,
        name,
        thk_livestock_uuid,
        status,
        chName,
        date,
    } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    //add to Object filter
    filter.is_name = is_name ?? '';
    filter.donation_hid = donation_hid ?? '';
    filter.name = name ?? '';
    filter.thk_livestock_uuid = thk_livestock_uuid ?? '';
    filter.status = status ?? '';
    filter.chName = chName ?? '';
    filter.date = date ?? '';

    newQueryParams.filter = filter;
    return newQueryParams;
};

export const KurbanListFilter = () => {

    const kurbanListUIContext = useKurbanListUIContext();
    const kurbanListUIProps = useMemo(() => {
        return {
            setQueryParams: kurbanListUIContext.setQueryParams,
            queryParams: kurbanListUIContext.queryParams,
            filterType: kurbanListUIContext.filterType,
        };
    }, [kurbanListUIContext]);


    // USE STATE
    const [channelName, setChannelName] = useState([]);
    const [kurbanList, setKurbanList] = useState([])


    const applyFilter = (values) => {
        const newQueryParams = prepareFilter(kurbanListUIProps.queryParams, values);
        if (!isEqual(newQueryParams, kurbanListUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            kurbanListUIProps.setQueryParams(newQueryParams);
        }
    };




    const kurbanFunction = async () => {
        await getKurbanList().then(response => {
            setKurbanList(response.data.data)
        }).catch(error => {
            console.log(error)
        })
    }
    const fetchChannel = async () => {
        const result = await requestCh.getChanelByType("");
        setChannelName(result.data.data);
    };

    useEffect(() => {
        kurbanFunction()
        fetchChannel()
        // eslint-disable-next-line
    }, []);

    return (
        <Formik initialValues={initialFilter.filter} onSubmit={(values) => {
            applyFilter(values);
            console.log(values)
        }}
        >
            {({ values, handleSubmit, handleBlur, setFieldValue }) => (
                <form onSubmit={handleSubmit} className="form form-label-right">

                    {/*ROW 1 BY DONATUR*/}
                    <div className="form-group row">
                        <div className="col-lg-4">
                            <Field
                                id="date"
                                name="date"
                                type="date"
                                className="form-control"
                                onChange={(e) => {
                                    setFieldValue('date', e.target.value)
                                    handleSubmit()
                                }}
                            />
                            <small className="form-text text-muted">
                                Cari Berdasarkan Tanggal Harian
                            </small>
                        </div>

                        {/*ROW 2*/}

                        <div className="col-lg-4">
                            <select
                                className="form-control"
                                name="is_name"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('is_name', e.target.value);
                                    handleSubmit();
                                }}
                            >
                                <option value="true">Ya</option>
                                <option value="false">Tidak</option>
                            </select>
                            <small className="form-text text-muted">
                                Tersedia Nama Pekurban
                            </small>
                        </div>

                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Search"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('name', e.target.value);
                                    handleSubmit();
                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Nama Pekurban
                            </small>
                        </div>




                    </div>

                    <div className="form-group row">
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="donation_hid"
                                placeholder="Search"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('donation_hid', e.target.value);
                                    handleSubmit();
                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> ID Donasi
                            </small>
                        </div>

                        {/* Channel UUID */}
                        {/* {showRekeningField && (
                            <div className="col-lg-4">
                                <select name="channel_name"
                                    className="form-control"
                                    onChange={e => {
                                        handleSubmit(e)
                                        setFieldValue('channel_name', e.target.value)
                                    }}>
                                    <option value="">--PILIH--</option>
                                    {
                                        kodeRek.map(row =>
                                            <option key={row.uuid} value={row.name}>{row.name}</option>,
                                        )
                                    }
                                </select>
                                <small className="form-text text-muted">
                                    <b>Cari</b> Nomor Rekening
                                </small>
                            </div>
                        )} */}

                        {/* Channel UUID */}
                        <div className="col-lg-4">
                            <select name="status"
                                className="form-control"
                                onChange={e => {
                                    handleSubmit(e)
                                    setFieldValue('status', e.target.value)
                                }}
                            >
                                <option value="">--PILIH--</option>
                                <option value="RECOG">RECOG</option>
                                <option value="SETTLE">SETTLE</option>
                                <option value="COLLECT">COLLECT</option>
                                <option value="DRAFT">DRAFT</option>
                                <option value="VOID">DELETE</option>
                                <option value="REQUEST_VOID">REQUEST DELETE</option>
                            </select>
                            <small className="form-text text-muted">
                                <b>Cari</b> Status
                            </small>
                        </div>

                        <div className="col-lg-4">
                            <select
                                className="form-control"
                                name="thk_livestock_uuid"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('thk_livestock_uuid', e.target.value);
                                    handleSubmit();
                                }}
                            >
                                <option value="">ALL</option>
                                {kurbanList.map(row =>
                                    <option key={row.uuid} value={row.uuid}>
                                        {row.name} - {row.price}
                                    </option>
                                )}
                            </select>
                            <small className="form-text text-muted">
                                Jenis Hewan Kurban
                            </small>
                        </div>

                    </div>

                    <div className='form-group row'>
                        <div className="col-lg-4">
                            <Autocomplete
                                name="chName"
                                options={channelName}
                                getOptionLabel={(option) => option ? `${option.bank ? option.bank.name : option.type} - ${option.name}${option.is_deleted ? " - [TERHAPUS]" : ""}` : ''}
                                onChange={(e, value) => {
                                    if (value) {
                                        setFieldValue('chName', value.uuid)
                                        handleSubmit()
                                    } else {
                                        setFieldValue('chName', "")
                                        handleSubmit()
                                    }
                                }}
                                value={channelName.length > 0 && channelName.find((option) => option.uuid === values.chName)}
                                // loading={channelName.length === 0 ? true : false}

                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Cari Channel"
                                        variant="outlined"
                                        disableClearable
                                        size="small"

                                    />
                                )}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> Nama Channel / Kode Rekening
                            </small>
                            {/* <select
                                className="form-control"
                                placeholder="Filter Type"
                                name="chName"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('chName', e.target.value);
                                    handleSubmit();
                                }}
                                value={values.chName}
                            >
                                <option value="">ALL</option>
                                {channelName.map(ch =>
                                    <option key={ch.uuid}
                                        value={ch.uuid}> {ch.bank ? ch.bank.name : ch.type} - {ch.name}</option>
                                )}
                            </select>
                            <small className="form-text text-muted">
                                <b>Cari</b> Nama Channel / Kode Rekening
                            </small> */}
                        </div>
                    </div>

                </form>
            )}
        </Formik>

    );

};

